let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gaQPp")).then(() => parcelRequire('8EYbC'));